import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ChipSelector, { ChipOption } from "../../../../components/common/form/ChipSelect/ChipSelector";
import CustomText from "../../../../components/common/general/CustomText/CustomText";

export interface InterestsEditorProps {
  value: string[];
  onChange: (value: string[]) => void;
  showHeader?: boolean;
}
export default function InterestsEditor({ value, onChange, showHeader }: InterestsEditorProps) {
  const { t } = useTranslation();
  const interestOptions: ChipOption[] = useMemo(
    () => [
      {
        key: "video_games",
        value: t("text.companion_onboarding_interest_video_games"),
        icon: <CustomText text="🎮" size="m" useTranslationText={false} style={undefined} />,
      },
      {
        key: "sports",
        value: t("text.companion_onboarding_interest_sports"),
        icon: <CustomText text="🏀" size="m" useTranslationText={false} style={undefined} />,
      },
      {
        key: "music",
        value: t("text.companion_onboarding_interest_music"),
        icon: <CustomText text="🎵" size="m" useTranslationText={false} style={undefined} />,
      },
      {
        key: "cooking",
        value: t("text.companion_onboarding_interest_cooking"),
        icon: <CustomText text="🍳" size="m" useTranslationText={false} style={undefined} />,
      },
      {
        key: "art_design",
        value: t("text.companion_onboarding_interest_art"),
        icon: <CustomText text="🎨" size="m" useTranslationText={false} style={undefined} />,
      },
      {
        key: "travel",
        value: t("text.companion_onboarding_interest_travel"),
        icon: <CustomText text="✈️" size="m" useTranslationText={false} style={undefined} />,
      },
      {
        key: "movies_tv",
        value: t("text.companion_onboarding_interest_movies"),
        icon: <CustomText text="🎬" size="m" useTranslationText={false} style={undefined} />,
      },
      {
        key: "reading",
        value: t("text.companion_onboarding_interest_reading"),
        icon: <CustomText text="📚" size="m" useTranslationText={false} style={undefined} />,
      },
      {
        key: "fitness",
        value: t("text.companion_onboarding_interest_fitness"),
        icon: <CustomText text="💪" size="m" useTranslationText={false} style={undefined} />,
      },
      {
        key: "technology",
        value: t("text.companion_onboarding_interest_technology"),
        icon: <CustomText text="💻" size="m" useTranslationText={false} style={undefined} />,
      },
      {
        key: "nature",
        value: t("text.companion_onboarding_interest_nature"),
        icon: <CustomText text="🌿" size="m" useTranslationText={false} style={undefined} />,
      },
      {
        key: "animals_pets",
        value: t("text.companion_onboarding_interest_pets"),
        icon: <CustomText text="🐾" size="m" useTranslationText={false} style={undefined} />,
      },
    ],
    [t]
  );

  return (
    <>
      {showHeader && (
        <CustomText style={{}} text="companion_onboarding_step3_title" useTranslationText size="l" weight="bold" />
      )}

      <ChipSelector options={interestOptions} selectedKeys={value ?? []} onSelectionChange={onChange} multiSelect />
    </>
  );
}
